import useResponsive from "libs/helpers/useResponsive";
import "./styles.scss";

import { ToastContainer, Slide } from "react-toastify";

const NotifyContainer = () => {
  const { isMobile } = useResponsive();

  return (
    <ToastContainer
      position={!!isMobile ? "top-center" : "top-right"}
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Slide}
    />
  );
};

export default NotifyContainer;
